const LANGUAGES = {
	PL: {
		name: 'Polski',
		flag: 'pl',
	},
	GB: {
		name: 'English',
		flag: 'gb',
	},
} as const;

export default LANGUAGES;
